module.exports = __webpack_public_path__ + "img/service7EN.13b66f4a.svg";